

import React, { Component } from 'react';



import {
    Text,
    View,
    TouchableOpacity,
    Dimensions,
    Image,
    TextInput,
    ActivityIndicator,
    Linking,
    Keyboard,
    Animated,
    Easing,


} from 'react-native';

import * as Animatable from 'react-native-animatable';

import { CustomCursor } from "react-svg-cursor";
import svg from "./svg.svg";


export default class Ostereierschiessen extends Component {



constructor() {
        super();

        this.animatedRotateY = new Animated.Value(0);
        this.value1 = 0;
        this.animatedRotateY.addListener(({ value }) => {
          this.value1 = value;
        });

        this.state = {

            testmodus: false,
            eierWidth: 85,
            eierData: [{'name':'ei01', 'punkte':50, top:69, left:23, scale:1, rotate: '2deg'},
                       {'name':'ei02', 'punkte':50, top:50, left:19, scale:0.6, rotate: '-2deg'},
                       {'name':'ei03', 'punkte':50, top:10, left:73, scale:0.8, rotate: '2deg'},
                       {'name':'ei04', 'punkte':50, top:70, left:45, scale:0.7, rotate: '-2deg'},
                       {'name':'ei05', 'punkte':50, top:86, left:34, scale:1, rotate: '2deg'},
                       {'name':'ei06', 'punkte':50, top:60, left:10, scale:1, rotate: '-2deg'},
                       {'name':'ei07', 'punkte':50, top:10, left:40, scale:0.8, rotate: '2deg'},
                       {'name':'ei08', 'punkte':50, top:34, left:86, scale:0.9, rotate: '-2deg'},
                       {'name':'ei09', 'punkte':50, top:45, left:70, scale:0.7, rotate: '2deg'},
                       {'name':'ei10', 'punkte':50, top:73, left:10, scale:0.5, rotate: '-2deg'},
                       {'name':'ei11', 'punkte':50, top:19, left:50, scale:0.6, rotate: '2deg'},
                       {'name':'ei12', 'punkte':50, top:23, left:2, scale:0.9, rotate: '-2deg'}],
            showStart: false,
            eier_level1: false,
            eier_level2: false,
            eier_level3: false,
            showFinish1: false,
            showFinish2: false,
            showFinish3: false,
            score: 0,
            level: 1,


        }


    }


componentDidMount() {


/*
    if ( this.state.testmodus ){
        this.state.eierData.forEach(function (item,index) {
            this.refs[item.name].fadeIn();
        }.bind(this));
    } else {
        this.refs[this.state.eierData[0].name].fadeIn();

    }

    if ( this.state.showStart ){
        setTimeout(() => {
                this.refs.ohren.swing();
                setTimeout(() => {
                    this.setState({showStart:false})
                }, 2000);
        }, 2000);
    }
*/
        this.setState({eier_level1:true });
        setTimeout(() => {
            //this.startAnimation();
        }, 1000);

}

startAnimation(){

         Animated.sequence([
              Animated.timing(this.animatedRotateY, {
                toValue: 1,
                duration: 15000,
                easing: Easing.linear,
              }),
         ]).start();

         this.timerHandle = setTimeout(() => {
                this.setState({ level: 2, showFinish1: true, eier_level1:false });
                this.timerHandle = 0;
                setTimeout(() => {
                    this.setState({ showFinish1: false, eier_level2:true });
                }, 3000);
         }, 15500);
}


startAnimation_level2(){

         this.animatedRotateY.setValue(0);
         Animated.sequence([
              Animated.timing(this.animatedRotateY, {
                toValue: 1,
                duration: 15000,
                easing: Easing.linear,
              }),
         ]).start();

         this.timerHandle = setTimeout(() => {
                this.setState({ level: 3, showFinish2: true });
                this.timerHandle = 0;
                setTimeout(() => {

                }, 3000);
         }, 15500);
}



getHorizontalRandomLeft(){
//int randomNum = (int)(Math.random() * 101); // 0 to 100
let eier_w = 100;
let left = ((Math.random() * 101)*300/100)-eier_w;
if ( left < eier_w ){
 left = left+eier_w;
}
return left;
}

getHorizontalRandomTop(){
let eier_h = 132;
let top = ((Math.random() * 101)*300/100)-eier_h;
if ( top < eier_h ){
 top = top+eier_h;
}
return top;
}

getTop(i){
let top = this.getBoxHeight()/100*i;
return top;
}
getLeft(i){
let left = this.getBoxWidth()/100*i;
return left;
}

getBoxWidth(){
return this.props.width-50;
}

getBoxHeight(){
return this.props.height-62;
}

startTimer(id){

    if (this.timerHandle) {
        clearTimeout(this.timerHandle);
        this.timerHandle = 0;
    }

     this.timerHandle = setTimeout(() => {
        this.refs[this.state.eierData[id].name].zoomOut(500);
        this.showNext(id+1);
        this.timerHandle = 0;
        }, 3000);

}

showNext(id){
    this.refs[this.state.eierData[id].name].lightSpeedIn();
    if ( id < 11 ){
        this.startTimer(id);
    } else {
        this.refs[this.state.eierData[id].name].zoomOut(500);
    }
}


getEierSize(){
let w = this.state.eierWidth;
let h = w*1.22;
let m = w;
return {w:w,h:h,m:m};
}

isGerade (number) {
    if (number % 2 == 0) {
        return true;
    } else {
        return false;
    }
};


isTablet(){
let isTablet = false;
if ( this.props.width>this.props.height ){
    isTablet = true;
}
return isTablet;
}



  render() {

        let eier = [];
        this.state.eierData.forEach(function (item,index) {
        eier.push(
                <Animatable.View ref={item.name} style={{ marginLeft:this.getEierSize().m, width:this.getEierSize().w, height:this.getEierSize().h, opacity:1 }}>
                <TouchableOpacity onPress={()=> {  this.setState({ score: this.state.score+item.punkte }); this.refs[item.name].flipOutX(500);  }} >
                <Image style={{ width: this.getEierSize().w, height:this.getEierSize().h, opacity:1,  }} resizeMode="contain" source={require("./images/"+item.name+".png")}  />
                { this.state.testmodus ?
                <Text style={{position:'absolute', fontSize:20, color:'#ffffff'}}>{item.name}</Text>:null
                }
                </TouchableOpacity>
                </Animatable.View>
                );
        }.bind(this));

        let eier2 = [];
        this.state.eierData.forEach(function (item,index) {
        eier2.push(
                <Animatable.View ref={item.name} animation="slideInDown" iterationCount={15} direction="alternate" style={{ marginLeft:this.getEierSize().m, width:this.getEierSize().w, height:this.getEierSize().h, opacity:1 }}>
                <TouchableOpacity onPress={()=> {  this.setState({ score: this.state.score+item.punkte }); this.refs[item.name].flipOutX(500);  }} >
                <Image style={{ width: this.getEierSize().w, height:this.getEierSize().h, opacity:1,  }} resizeMode="contain" source={require("./images/"+item.name+".png")}  />
                { this.state.testmodus ?
                <Text style={{position:'absolute', fontSize:20, color:'#ffffff'}}>{item.name}</Text>:null
                }
                </TouchableOpacity>
                </Animatable.View>
                );
        }.bind(this));

        let eier3 = [];
        this.state.eierData.forEach(function (item,index) {
        eier3.push(
                <Animatable.View ref={item.name} animation={this.isGerade(index)?"slideInDown":"slideInUp"} iterationCount={15} direction="alternate" style={{ marginLeft:this.getEierSize().m, width:this.getEierSize().w, height:this.getEierSize().h, opacity:1 }}>
                <TouchableOpacity onPress={()=> {  this.setState({ score: this.state.score+item.punkte }); this.refs[item.name].flipOutX(500);  }} >
                <Image style={{ width: this.getEierSize().w, height:this.getEierSize().h, opacity:1,  }} resizeMode="contain" source={require("./images/"+item.name+".png")}  />
                { this.state.testmodus ?
                <Text style={{position:'absolute', fontSize:20, color:'#ffffff'}}>{item.name}</Text>:null
                }
                </TouchableOpacity>
                </Animatable.View>
                );
        }.bind(this));


    return (

    <>
      <style type="text/css">{`
        @font-face {
          font-family: 'FontAwesome';
          src: url(${require('react-native-vector-icons/Fonts/FontAwesome.ttf')}) format('truetype');
        }
        @font-face {
          font-family: 'MaterialCommunityIcons';
          src: url(${require('react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf')}) format('truetype');
        }
        @font-face {
          font-family: 'Lovers Quarrel';
          src: url(${require('./fonts/Lovers Quarrel.otf')}) format('opentype');
        }
        @font-face {
          font-family: 'CaveatBrush-Regular';
          src: url(${require('./fonts/CaveatBrush.ttf')}) format('truetype');
        }
        @font-face {
          font-family: 'Montserrat-Regular';
          src: url(${require('./fonts/Montserrat-Regular.ttf')}) format('truetype');
        }
        @font-face {
          font-family: 'Montserrat-Medium';
          src: url(${require('./fonts/Montserrat-Medium.ttf')}) format('truetype');
        }
        @font-face {
          font-family: 'Montserrat-Bold';
          src: url(${require('./fonts/Montserrat-Bold.ttf')}) format('truetype');
        }
      `}</style>

        <CustomCursor
          component={svg}
          isDisabled={false}
          width={80}
          height={80}
          transform="translate(-28px, -50px) scale(-1, 1) rotateZ(0deg) "
        />

<Image style={{ position:'absolute', width: this.props.width, height:this.props.height, opacity:1,  }} resizeMode="cover" source={require("./images/hintergrund.jpg")}  />

<Image style={{ position:'absolute', top:(this.props.height/2)-((this.props.width-50)/2), width: this.props.width-50, height:this.props.width-50, opacity:1, alignSelf:'center'  }} resizeMode="contain" source={require("./images/Zelt2.png")}  />

<View style={{ overflow:'hidden', position:'absolute', zIndex:1, top: (this.props.height/2)-this.getEierSize().h, left: (this.props.width-50)/80*9, height: this.getEierSize().h*2, width:(this.props.width-50)-((this.props.width-50)/80*9), }}>

{ this.state.eier_level1 ?
<Animated.View style={{ top: this.getEierSize().h, left:this.animatedRotateY.interpolate({  inputRange: [0, 1],  outputRange: [this.props.width-this.props.width, -(this.state.eierData.length*(this.getEierSize().w+this.getEierSize().m)) ]}), width: (this.state.eierData.length*(this.getEierSize().w+this.getEierSize().m)), backgroundColor:this.state.testmodus?'#ff00ff':'transparent'}}>
    <View style={{ flexDirection:'row' }}>
    {eier}
    </View>
</Animated.View>:null
}
{ this.state.eier_level2 ?
<Animated.View style={{ top: this.getEierSize().h, left:this.animatedRotateY.interpolate({  inputRange: [0, 1],  outputRange: [this.props.width, -(this.state.eierData.length*(this.getEierSize().w+this.getEierSize().m)) ]}), width: (this.state.eierData.length*(this.getEierSize().w+this.getEierSize().m)), backgroundColor:this.state.testmodus?'#ff00ff':'transparent'}}>
    <View style={{ flexDirection:'row' }}>
    {eier2}
    </View>
</Animated.View>:null
}
{ this.state.eier_level3 ?
<Animated.View style={{ top: this.getEierSize().h, left:this.animatedRotateY.interpolate({  inputRange: [0, 1],  outputRange: [this.props.width, -(this.state.eierData.length*(this.getEierSize().w+this.getEierSize().m)) ]}), width: (this.state.eierData.length*(this.getEierSize().w+this.getEierSize().m)), backgroundColor:this.state.testmodus?'#ff00ff':'transparent'}}>
    <View style={{ flexDirection:'row' }}>
    {eier3}
    </View>
</Animated.View>:null
}

</View>



                <Animated.View style={{ position:'absolute', top:200, left:150, width:100, height:132, opacity:1, transform:[{scale:1},{rotate:'0deg'}] }}>
                <TouchableOpacity onPress={()=> {  this.startAnimation();  }} >
                <Image style={{ width: 100, height:132, opacity:1,  }} resizeMode="contain" source={require("./images/ohren.png")}  />
                </TouchableOpacity>
                </Animated.View>

                <Animated.View style={{ position:'absolute', bottom:20, left:150, width:300, height:200, opacity:1, transform:[{scale:0.5},{rotate:'0deg'}] }}>
                <TouchableOpacity onPress={()=> {  this.startAnimation();  }} >
                <Image style={{ width: 300, height:200, opacity:1,  }} resizeMode="contain" source={require("./images/blumen.png")}  />
                </TouchableOpacity>
                </Animated.View>

<Text style={{ alignSelf:'center', position:'absolute', bottom:0, fontSize:this.props.width/100*12, fontFamily:'Amatic', textAlign:'center', color:'#2ba2b3'}}>{'Score: '+this.state.score+'  ' }</Text>

{
this.state.showStart ?
<View style={{ position:'absolute', width:'100%', height: '100%', backgroundColor:'#2ba2b3', alignItems:'center'}}>
<Animatable.Image ref="ohren" animation="slideInUp" style={{ position:'absolute', top:(this.props.height/2)-(this.props.height/4.5), width: this.props.height/3, height:this.props.height/3, opacity:1,  }} resizeMode="cover" source={require("./images/ohren.png")}  />
<Image style={{ position:'absolute', width: this.props.width, height:this.props.height, opacity:1,  }} resizeMode="cover" source={require("./images/gras.png")}  />
<Text style={{position:'absolute', bottom:this.props.height/100*15, fontSize:this.props.width/100*12, fontFamily:'Amatic', textAlign:'center', color:'#2ba2b3'}}>{this.props.width<this.props.height?'Frohes\nOsterschießen':'Frohes Osterschießen'}</Text>
</View>:null
}

{ this.state.showFinish1 ?
<View style={{ position:'absolute', width:'100%', height: '100%', alignItems:'center', justifyContent:'center'}}>
        <Animatable.View animation="fadeInDownBig" style={{ width:this.isTablet()?this.props.width/3:this.props.width-50, height:400, backgroundColor:'#ffffff', justifyContent:'center', alignItems:'center', borderColor:'#22a2f3', borderWidth:3, borderRadius:10 }}>
        <Text style={{ margin:50, fontSize:this.props.height/100*5, fontFamily:'Amatic', textAlign:'center', color:'#22a2f3'}}>{'Die 1. Runde ist geschafft!\n\nDu hast '+this.state.score+' Punkte bisher erspielt.'}</Text>
        <TouchableOpacity style={{ width: '50%', height:60, backgroundColor:'#22a2f3', borderRadius:10, justifyContent:'center', alignItems:'center' }} onPress={()=> {  this.startAnimation_level2();  }} >
        <Text style={{ fontSize:20, textAlign:'center', color:'#ffffff'}}>{'Starte Runde 2'}</Text>
        </TouchableOpacity>
        </Animatable.View>
</View>:null
}
{ this.state.showFinish2 ?
<View style={{ position:'absolute', width:'100%', height: '100%', alignItems:'center', justifyContent:'center'}}>
        <Animatable.View animation="fadeInDownBig" style={{ width:this.isTablet()?this.props.width/3:this.props.width-50, height:400, backgroundColor:'#ffffff', justifyContent:'center', alignItems:'center', borderColor:'#22a2f3', borderWidth:3, borderRadius:10 }}>
        <Text style={{ margin:50, fontSize:this.props.height/100*5, fontFamily:'Amatic', textAlign:'center', color:'#22a2f3'}}>{'Die 2. Runde ist geschafft!\n\nDu hast '+this.state.score+' Punkte bisher erspielt.'}</Text>
        <TouchableOpacity style={{ width: '50%', height:60, backgroundColor:'#22a2f3', borderRadius:10, justifyContent:'center', alignItems:'center' }} onPress={()=> {  this.startAnimation_level3();  }} >
        <Text style={{ fontSize:20, textAlign:'center', color:'#ffffff'}}>{'Starte Runde 3'}</Text>
        </TouchableOpacity>
        </Animatable.View>
</View>:null
}


</>
    );
  }
}

